import type { StepName } from "createProposal/types/form"

export enum DispatchActionMethod {
  NEXT_STEP,
  PREVIOUS_STEP,
  TO_STEP,
  SET_GOVERNOR_PROPOSAL_STEPS,
  RESET_SIMULATION,
}

export type DispatchAction =
  | { method: DispatchActionMethod.NEXT_STEP }
  | { method: DispatchActionMethod.PREVIOUS_STEP }
  | {
      method: DispatchActionMethod.TO_STEP
      payload: { to: StepName; shouldRunSimulation?: boolean | undefined }
    }
  | { method: DispatchActionMethod.SET_GOVERNOR_PROPOSAL_STEPS }
  | { method: DispatchActionMethod.RESET_SIMULATION }
